export enum initialDiscountsEnum {
    "AGENT_DISCOUNT" = "FIVE_PERCENT",
    "MANAGER_DISCOUNT" = "30",
    "SPECIAL_DISCOUNT" = "15"
}